import { getAddressBookDisplayValue } from "~/shared/components/fields/address-postal-code-search.tsx";
import type { AddressBookItemSummary } from "~/shared/schemas/address-book-schema.ts";

export { IDENTITY_ADDRESS_FIELDS } from "./address-identity-fields.ts";

/**
 * True when the stop is a pristine, unedited saved address book entry.
 *
 * Invariant: `addressBookItemId !== 0` ⟺ the stop's identity fields still equal a
 * saved address book entry. The invariant is maintained at the three write
 * boundaries — select (`setSelectedAddressBookItem`), edit
 * (`updateSelectedAddressBookItem` clears the id on an identity-field edit), and
 * reload (`useQuoteLoader` reconstructs with id 0 and the name-strict resolution
 * reassigns it only on an exact match) — and read everywhere through this
 * predicate.
 */
export const isPristineSavedAddress = (
	item: AddressBookItemSummary | null | undefined,
): item is AddressBookItemSummary => !!item && item.addressBookItemId !== 0;

/**
 * The label to show in the "Saved Address" search box for a stop: the formatted
 * saved address while pristine, otherwise blank (the data lives in the fields
 * below). Because it derives purely from the invariant it is correct in-session
 * and on reload without any remembered component state.
 */
export const getAppliedAddressLabel = (
	item: AddressBookItemSummary | null | undefined,
): string =>
	isPristineSavedAddress(item) ? getAddressBookDisplayValue(item) : "";
